(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('contact', {
            // parent: 'entity',
            parent: 'app',
            url: '/contact?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.contact.home.title'
            },
            views: {
                // 'content@': {
                'contact@': {
                    templateUrl: 'app/entities/contact/contacts.html',
                    controller: 'ContactController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('contact-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/contact/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.contact.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contact/contact-detail.html',
                    controller: 'ContactDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Contact', function($stateParams, Contact) {
                    return Contact.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'contact',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('contact-detail.edit', {
            // parent: 'contact-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/contact/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact/contact-dialog.html',
                    controller: 'ContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contact', function(Contact) {
                            return Contact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contact.new', {
            // parent: 'contact',
            parent: 'app',
            // url: '/new',
            url: '/contact/new',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact/contact-dialog.html',
                    controller: 'ContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: null,
                                createdBy: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                phone: null,
                                fax: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('contact', null, { reload: true });
                }, function() {
                    $state.go('contact');
                });
            }]
        })
        .state('contact.edit', {
            // parent: 'contact',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/contact/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact/contact-dialog.html',
                    controller: 'ContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contact', function(Contact) {
                            return Contact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contact', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contact.delete', {
            // parent: 'contact',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/contact/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact/contact-delete-dialog.html',
                    controller: 'ContactDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contact', function(Contact) {
                            return Contact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contact', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );

    }

})();
